import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import CompaniesSearchHome from './components/companiesdb/CompaniesSearchHome.jsx';
import CompanyShareableCard from './components/companiesdb/CompanyShareableCard.jsx';



function App() {

  return (
    <Router>
      <Switch>
        <Route path="/company/shareable-card/:id" children={<CompanyShareableCard/>}>
        </Route>
        <Route path="/company/">
          <CompaniesSearchHome />
        </Route>
        <Route path="/">
          <Redirect to="/company/" />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
